module.exports = __webpack_public_path__ + "img/checkin.17b21a98.svg";